module.exports = "/packs/step1-ca84fa41d0723d1122f3af2874c26c48.png";